import { gsap } from "gsap";

export default class AboutMain  {
	constructor(elm) {
        this.elm = elm;

        this.spheres = this.elm.querySelectorAll('[data-about-main-sphere]');
		this.init();
	}

	init() {

        let mm = gsap.matchMedia();

        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)"
          }, (context) => {

            let { isDesktop, isMobile, reduceMotion } = context.conditions;

            if(reduceMotion) {
                gsap.set(this.spheres, {
                    translateX: '-20%',
                    scaleY: 2,
                });

                return;
            }

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.elm,
                    start: "top bottom",
                    end: 'center top',
                    scrub: 1,
                }
            });

            tl.to(this.spheres, {
                translateX: '-20%',
                scaleY: 2,
                ease: 'power.inOut',
                duration: 1,
                stagger: -0.3
            });

        });

	}
}
